import Route from 'cio/routes/base';
import { inject as service } from '@ember/service';
import DS from 'ember-data';
import ObjectModel from 'cio/models/object';
import Transition from '@ember/routing/-private/transition';
import IndexController from './controller';

export default class IndexRoute extends Route {
  @service store!: DS.Store;

  model() {
    let { object_id } = this.paramsFor('object') as Record<string, string>;
    return this.store.findRecord('object', object_id);
  }

  setupController(controller: IndexController, model: ObjectModel, transition: Transition) {
    super.setupController(controller, model, transition);
    controller.fetchLogs.perform();
  }

  deactivate() {
    super.deactivate();

    (this.controller as IndexController).set('searchTerm', '');
  }
}
